import { Component, ObjectManager } from '../../../concepts/objects';
import { resolve } from '../../Container';
import { DefineSimpleDimension } from '../dataExport/addons/SimpleDimension';
import { FromFirstMatchExportAdapter } from '../dataExport/ExportAdapter';
import { Sticky } from '../paper/Sticky';
import { Topic } from './Topic';
import { TopicAssocation } from './TopicAssociations';

export class AssociatedTopicExportAdapter extends FromFirstMatchExportAdapter {

    @resolve(ObjectManager) private objects!: ObjectManager;

    protected selector = (c: Component) => c.is(Sticky);

    public readonly id = 'TopicAssocations';
    public readonly label = 'Associations';
    public readonly columns = [
        DefineSimpleDimension(
            Sticky,
            'Topic',
            'Adds a column that contains the label of the Topic that each Sticky Note is grouped under.',
            (c: Component) => {
                const id = TopicAssocation.get(c);
                const topic = this.objects.getMaybe(id, Topic);
                return topic?.label ?? '';
            }
        ),
    ];
}
